import { SmallError } from '../../icons/SmallError';
import { Typography, Button } from '@mui/material';
import MUISnackbar from '@mui/material/Snackbar';
import { styled } from '@mui/material/styles';

const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  width: '400px',
  minHeight: '50px',
  background: 'white',
  padding: '1em',
  borderRadius: '3px',
  boxShadow: '0 12px 24px 4px rgba(40,42,43,0.2)',
  borderLeft: '4px solid #D61F1F',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    marginLeft: '0.5em',
  },
}));

const ContentContainer = styled('div')({
  display: 'flex',
  lineHeight: 1.8,
});

const IconContainer = styled('div')({
  display: 'flex',
  padding: '0 1.3em 0 0.3em',
  transform: 'translateY(3px)',
});

interface SnackbarProps {
  open: boolean;
}

/**
 * This Snackbar component is used to handle an edge case where a user grants their browser
 * permission to access their camera and/or microphone, and then later revokes this permission.
 * When this occurs, this Snackbar will display an error asking the user to reset their device permissions,
 * and refresh the app.
 */

export function Snackbar({ open }: SnackbarProps) {
  return (
    <MUISnackbar
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={open}
      autoHideDuration={110000}
    >
      <Container>
        <ContentContainer>
          <IconContainer>
            <SmallError />
          </IconContainer>
          <div>
            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
              Device change: unable to connect -
            </Typography>
            <Typography variant="body1">
              {' '}
              please reset your browser/OS permissions (which may be in your "Settings") and refresh this page.
            </Typography>
            <Button style={{ marginTop: '1em' }} variant="outlined" onClick={() => window.location.reload()}>
              Refresh page
            </Button>
          </div>
        </ContentContainer>
      </Container>
    </MUISnackbar>
  );
}
